var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isFullscreen)?_c('button',{staticStyle:{"white-space":"nowrap","max-width":"6em","flex-grow":"0","flex-shrink":"1"},on:{"click":_vm.toggleFullscreen}},[_vm._v(" fullscreen! ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }